export enum AuthenticationActionType {
  AUTHENTICATION_CALLBACK = '@@authentication/AUTHENTICATION_CALLBACK',
  AUTHENTICATION_CALLBACK_DONE = '@@authentication/AUTHENTICATION_CALLBACK_DONE',
  SET_EXPERIENCE = '@@authentication/SET_EXPERIENCE',
}
